import * as S from './ActivitiesPartnersPreviews.styles';
import Link from 'next/link';
import URL from '@/common/app/utils/urlsUtils';
import { Location } from '@/shared/images/icons/Location';
import { IPartnersItem } from '@/common/service/api/Partners/Partners.domain';
import emptyImg from '@/shared/images/Images/EmptyImg.png';
import { ReviewsBlock } from '@/entities/Reviews/ui/ReviewBlock';

const ActivitiesPartnersPreview = (props: IPartnersItem) => {
    const {
        activity,
        url,
        title,
        rating_stars,
        description,
        address,
        number_of_trips,
        rate_count,
        rating,
    } = props;

    const rateCount = Math.round(rate_count);

    return (
        <Link href={url.toLowerCase()} passHref>
            <S.Container data-test-id="Partners_card">
                <S.ImgWrap>
                    <S.Gradient />
                    <S.Image
                        src={`${URL.image}/activity/${activity.id}/1000x500/${activity.slug}.jpg`}
                        alt={title}
                        width="1000"
                        height="500"
                        loading="lazy"
                        decoding="async"
                        onError={({ currentTarget }) => {
                            currentTarget.onerror = null;
                            currentTarget.src = `${emptyImg.src}`;
                        }}
                    />
                </S.ImgWrap>
                <S.DescriptionWrapper>
                    <S.Title>{title}</S.Title>
                    {!!address && (
                        <S.Address>
                            <Location /> &nbsp;
                            {address}
                        </S.Address>
                    )}

                    {Boolean(description) && <S.Description>{description}</S.Description>}
                </S.DescriptionWrapper>
                <S.BottomWrapper>
                    <ReviewsBlock
                        ratingStars={rating_stars}
                        rating={rating}
                        rateCount={rateCount}
                        emptyReviewsMsg="Recently added"
                    />
                    <S.ButtonWrapper>
                        {number_of_trips > 1 ? (
                            <S.ExperienceText>{number_of_trips} experiences</S.ExperienceText>
                        ) : (
                            <S.ExperienceText>{number_of_trips} experience</S.ExperienceText>
                        )}
                    </S.ButtonWrapper>
                </S.BottomWrapper>
            </S.Container>
        </Link>
    );
};

export { ActivitiesPartnersPreview };
